<template>
  <div class="vl-account">
    <div class="invariable">
      <div class="stepTitle">
        <span>服务企业账号激活</span> <br>
        <span>SERVICE ENTERPRISE ACCOUNT ACTIVATION</span>
      </div>
    </div>
    <div class="process">
      <ul>
        <li :class="{ 'atPresent': active == index,'EXIST': index < active || active == stepList.length - 1}"
            v-for="(item, index) in stepList" :key="index">
          <i>{{index + 1}}</i>
          <span>{{item.name}}</span>
        </li>
      </ul>

      <el-form :model="formInline" label-width="160px" ref="form" style="width: 65%;margin: 30px auto 0;"
               :rules="rules">
        <el-form-item label="账号激活码：" v-if="active == 0" prop="code">
          <el-input class="dispose" v-model="formInline.code" auto-complete="on" placeholder="请输入账号激活码" maxlength="10"></el-input>
        </el-form-item>

        <el-form-item label="公司名称：" v-if="active == 1" prop="companyName">
          <el-input v-model="formInline.companyName" auto-complete="on" disabled placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用号：" v-if="active == 1" prop="creditCode">
          <el-input v-model="formInline.creditCode" auto-complete="on" disabled placeholder="请输入统一社会信用号"></el-input>
        </el-form-item>
        <el-form-item label="公司简称：" v-if="active == 1" prop="companySimpleName">
          <el-input v-model="formInline.companySimpleName" auto-complete="on" disabled placeholder="请输入公司简称">
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱地址：" v-if="active == 1" prop="companyEmail">
          <el-input v-model="formInline.companyEmail" class="dispose" :disabled="isDis" placeholder="请输入邮箱地址" maxlength="60">
            <span slot="suffix" class="blueFont" @click="sendCode" :disabled="isDis">{{showSpan}}</span>
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱验证码：" v-if="active == 1" prop="mailboxCode">
          <el-input class="dispose" v-model="formInline.mailboxCode" auto-complete="on" placeholder="请输入邮箱验证码" maxlength="6">
          </el-input>
        </el-form-item>
        <el-form-item label="新密码：" v-if="active == 1" prop="loginPwd">
          <input type="password" name="password" style="position: absolute;left: -10000px;">
          <el-input v-model="formInline.loginPwd" auto-complete="on" show-password class="pwdInput"
                    placeholder="请输入新密码" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" v-if="active == 1" prop="affirmCipher">
          <el-input v-model="formInline.affirmCipher" auto-complete="on" show-password class="pwdInput"
                    placeholder="请确认密码" maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="姓名：" v-if="active == 2" prop="companyContacts">
          <el-input class="dispose" v-model="formInline.companyContacts" auto-complete="on" maxlength="30" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码：" v-if="active == 2" prop="companyContactsIdCode">
          <el-input class="dispose" v-model="formInline.companyContactsIdCode" auto-complete="on" placeholder="请输入身份证号码"
                    maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" v-if="active == 2" prop="companyContactsPhone">
          <el-input v-model="formInline.companyContactsPhone" auto-complete="on" class="dispose" :disabled="isDis"
                    placeholder="请输入手机号码" maxlength="11">
            <span slot="suffix" class="blueFont" @click="sendPhoneCode">{{showSpan}}</span>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码：" v-if="active == 2" prop="verificationCode">
          <el-input class="dispose" v-model="formInline.verificationCode" auto-complete="on" placeholder="请输入验证码" maxlength="6">
          </el-input>
        </el-form-item>

        <div v-if="active == 3" class="accomplish">
          <img src="../../../assets/img/activeAccount/accomplish.png" alt="">
          <p>您已完成账号激活</p>
          <el-button type="primary" v-if="active == 3" style="margin-top: 36px;" @click="toLogIn">现在登录</el-button>
        </div>

        <el-form-item>
          <el-button type="primary" v-if="active != 3" @click="next('form')">下一步</el-button>
        </el-form-item>

        <el-form-item  v-if="active == 1" prop="mailboxCode">
          <div class="dealCont">
            设置密码说明：<br />
            1、长度为8-15个字符<br />
            2、至少包含大写字母、小写字母、数字、特殊字符的组合，特殊字符：!@#$%^&*￥……<br />
            3、不能出现3个或3个以上连续的数字或字母，如123，ABC,abc<br />
            4、不能出现3个或3个以上重复的数字或字母，如111，AAA,aaa<br />
          </div>
        </el-form-item>
        <el-form-item  v-if="active == 2" prop="mailboxCode">
          <div class="dealCont">
            请输入归属地为宁夏的手机号码，否则将收不到短信验证码。<br />
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  import {
    CommonPostCompanySendEmailCode,
    CommonPostCompanySendMessageCode,
    CommonGetCompanyActivateCode,
    CommonPostCompanyActivateEmail,
    CommonPostCompanyActivateMessage
  } from '@/views/index/api/api.common.js';
  export default {
    data() {
      const idCardValidity = (rule, code, callback) => {
        var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
        var tip = ""
        var pass = true
        if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
          tip = "身份证号格式错误"
          pass = false;
        } else if (!city[code.substr(0, 2)]) {
          // tip = "地址编码错误"
          tip = "身份证输入错误"
          pass = false
        } else {
          // 18位身份证需要验证最后一位校验位
          if (code.length === 18) {
            code = code.split('')
            // ∑(ai×Wi)(mod 11)
            // 加权因子
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
            // 校验位
            var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
            var sum = 0
            var ai = 0
            var wi = 0
            for (var i = 0; i < 17; i++) {
              ai = code[i]
              wi = factor[i]
              sum += ai * wi
            }
//            var last = parity[sum % 11];
            if (parity[sum % 11] != code[17]) {
              tip = "身份证输入错误"
              pass = false
            }
          }
        }
        if (!pass) {
          callback(new Error(tip))
        } else {
          callback()
        }
      }

      const affirm = (rule, code, callback) => {
        if (this.formInline.loginPwd != code) {
          callback(new Error("密码输入不一致，请重新确认密码。"))
        } else {
          callback()
        }
      }
      return {
        stepList: [{
          name: "验证激活码"
        }, {
          name: "账号信息"
        }, {
          name: "联系人信息"
        }, {
          name: "完成"
        }],
        active: 0,
        companyInfo: {},
        formInline: {
          companyId: null,
          code: null,
          companyName: null,
          creditCode: null,
          companySimpleName: null,
          companyEmail: null,
          mailboxCode: null,
          loginPwd: null,
          affirmCipher: null,
          companyContacts: null,
          companyContactsIdCode: null,
          companyContactsPhone: null,
          verificationCode: null
        },
        showSpan: "发送验证码",
        isDis: false,
        time: 60,
        rules: {
          code: [
            { required: true, message: "请输入账号激活码", trigger: "blur" },
            {
              pattern: "^.{10}$",
              message: "请输入十位激活码",
              trigger: "blur"
            }
          ],
          companyName: [
            { required: true, message: "请输入公司名称", trigger: "blur" },
          ],
          creditCode: [
            { required: true, message: "请输入统一社会信用号", trigger: "blur" },
          ],
          companySimpleName: [
            { required: true, message: "请输入公司简称", trigger: "blur" },
          ],
          companyEmail: [
            { required: true, message: "请输入邮箱地址", trigger: "blur" },
            {
              pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
              message: "请输入正确的邮箱地址",
              trigger: "blur"
            }
          ],
          mailboxCode: [
            { required: true, message: "请输入邮箱验证码", trigger: "blur" },
            {
              pattern: /^\d{6}$/,
              message: "请输入正确的验证码",
              trigger: "blur",
            },
          ],
          loginPwd: [
            { required: true, message: "请输入新密码", trigger: "blur" },
            {
              pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&！@#￥%……&])[0-9a-zA-Z!@#$%^&！@#￥%……&]{8,15}$/,
              message: "要求长度8~15位，大写字母+小写字母+数字+特殊字符的组合",
              trigger: "blur",
            }
          ],
          affirmCipher: [
            { required: true, message: "请确认密码", trigger: "blur" },
            {
              validator: affirm, trigger: 'blur'
            }
          ],
          companyContacts: [
            { required: true, message: "请输入姓名", trigger: "blur" },
            {
              pattern: /^(?:[\u4e00-\u9fa5]{2,30})$/,
              message: "请输入正确的姓名",
              trigger: "blur",
            },
          ],
          companyContactsIdCode: [
            { required: true, message: '请输入身份证号码', trigger: 'blur' },
            { min: 18, max: 18, message: '请输入18位身份证号码', trigger: 'blur' },
            { validator: idCardValidity, trigger: 'blur' },
          ],
          companyContactsPhone: [
            { required: true, message: "请输入手机号码", trigger: "blur" },
            {
              pattern: /^1[3456789]\d{9}$/,
              message: "请输入正确的手机号码",
              trigger: "blur",
            },
          ],
          verificationCode: [
            { required: true, message: "请输入验证码", trigger: "blur" },
            {
              pattern: /^\d{6}$/,
              message: "请输入正确的验证码",
              trigger: "blur",
            },
          ],
        }
      }
    },
    mounted() {
    },
    methods: {
      /**
       * 处理下一步回调
       * */
      todoNext(data) {
        if (this.active == 0) {
          this.formInline.companyId = data.companyId;
          this.formInline.companyName = data.companyName;
          this.formInline.companySimpleName = data.companySimpleName;
          this.formInline.creditCode = data.creditCode;
          this.formInline.companyEmail = data.appContactsEmail;
        }
        this.active += 1;
        if (this.active == 2) {
          this.time = 0;
          this.isDis = false;
          this.showSpan = "发送验证码";
        }
      },
      rsaEncrypt(data) {
        // 公钥
        let PUBLIC_KEY = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAg8DC7bojdiFoqNjZHD+beD2sZnjwXJ17OyvpmRdxlTK2ABzWKm1ugid4Bo66z1IIu78t8JO7Fms92QR+J/w6ykIUzRGqsmp3j1e47boK0zuYgp5z/afQrL4F+G5NW3Wb2626mmM3G4WPho9M88E+v5j2y9wZTM7az1KomKKEvBwY2cROJFaYp04OSFJo9aee5ynGX66rgr1zStEPaz0jW0v4g7mrkEnu6p1EgW3Z8n7sieUqTYk+yn6lNf3lnb4e6QUAb1gpG0+9DiTDvAzePazjX3U7BTFOlMkBm6PFx+x+LTNUIrRn+2EBOYP2TKiZoDSOQS1jsuPcyOSYEhzzcQIDAQAB';
        // 使用公钥加密
        let encrypt = new JSEncrypt()
        encrypt.setPublicKey(PUBLIC_KEY)
        let result = encrypt.encrypt(data)
        return result
      },
      decrypt(msg) {
        const privateKey = ''
        let decrypt = new JSEncrypt()
        decrypt.setPrivateKey(privateKey)
        var decryptMsg = decrypt.decrypt(msg)
        return decryptMsg
      },
      // 下一步
      next() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            let obj = {};
            if (this.active == 0) {
              obj.activationCode = this.formInline.code;
              CommonGetCompanyActivateCode(obj).then(res => {
                if (res && res.code =='00000') {
                  this.todoNext(res.result)
                }
              })
            } else if (this.active == 1) {
              obj.companyId = this.formInline.companyId;
              obj.companyEmail = this.formInline.companyEmail;
              obj.verificationCode = this.formInline.mailboxCode;
              // obj.loginPwd = this.rsaEncrypt(this.formInline.loginPwd);
              obj.loginPwd = this.formInline.loginPwd;
              obj.type = "1";

              CommonPostCompanyActivateEmail(obj).then(res => {
                if (res && res.code =='00000') {
                  this.todoNext(res.result)
                }
              })
            } else if (this.active == 2) {
              obj.companyId = this.formInline.companyId;
              obj.type = "1";
              obj.companyContacts = this.formInline.companyContacts;
              obj.companyContactsIdCode = this.formInline.companyContactsIdCode;
              obj.companyContactsPhone = this.formInline.companyContactsPhone;
              obj.verificationCode = this.formInline.verificationCode;

              CommonPostCompanyActivateMessage(obj).then(res => {
                if (res && res.code =='00000') {
                  this.todoNext(res.result)
                }
              })
            }
          }
        });
      },
      // 发送邮箱验证码
      sendCode() {
        this.$refs["form"].validateField('companyEmail', val => {
          if (!val) {
            if (!this.isDis) {
              let params = {
                companyId: this.formInline.companyId,
                companyEmail: this.formInline.companyEmail,
                type: "1",
                activationCode: this.formInline.code
              }
              CommonPostCompanySendEmailCode(params).then(res => {
                if (res) {
                  this.time = 60;
                  this.timer()
                }
              })
            }
          }
        })
      },
      // 发送手机验证码
      sendPhoneCode() {
        this.$refs["form"].validateField('companyContactsPhone', val => {
          if (!val) {
            if (!this.isDis) {
              let params = {
                companyId: this.formInline.companyId,
                companyContactsPhone: this.formInline.companyContactsPhone,
                type: "1"
              }
              CommonPostCompanySendMessageCode(params).then(res => {
                if (res) {
                  this.time = 60;
                  this.timer()
                }
              })
            }
          }
        })
      },
      //发送验证码倒计时
      timer() {
        if (this.time > 0) {
          this.isDis = true;
          this.time--;
          this.showSpan = this.time + "秒";
          setTimeout(this.timer, 1000);
        } else {
          this.time = 0;
          this.showSpan = "发送验证码";
          this.isDis = false;
        }
      },
      // 跳转首页 去登录
      toLogIn() {
        this.$router.push({ name: "home" });
      },
    },
  }
</script>
<style lang="scss">
  .vl-account {
    width:1200px;
    margin:0 auto;
    background: #fff;
    margin-top: 20px;
    padding-bottom: 200px;
    .blueFont {
      color: #4286f5;
    }
    .invariable {
      height: 200px;
      background: url(../../../assets/img/activeAccount/setting.png) no-repeat center;
      background-size: 100% 100%;
      position: relative;
    }
    .invariable > .stepTitle {
      font-size: 24px;
      color: #A7CCF2;
      font-weight: bold;
      position: absolute;
      top: 70px;
      left: 220px;
      line-height: 35px !important;
    }
    .invariable > .stepTitle > span:first-child {
      color: #3F7BBB;
    }
    .dealCont {
      line-height: 20px;
      font-family: 'Arial Normal', 'Arial', sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 13px;
      letter-spacing: normal;
      color: #333333;
    }
    .accomplish {
      text-align: center;
      margin-bottom: 30px;
    }
    .accomplish > img {
      margin-top: 60px;
      display: inline-block;
    }
    .accomplish > p {
      padding-top: 20px;
      font-size: 24px;
      font-weight: bold;
      color: #4286F5;
    }
    .reset {
      text-align: center;
      margin-top: 30px;
    }
    .reset > i {
      padding: 20px;
      border: 1px solid #4286F5;
      border-radius: 50%;
      color: #4286F5;
    }
    .reset > .success {
      font-size: 18px;
      color: #333;
      padding: 40px 0;
    }
    .reset > .back {
      color: #999;
      padding-bottom: 20px;
    }
    .el-form-item {
      margin-bottom: 18px !important;
    }
    .el-form-item:last-child {
      /* margin-bottom: 200px !important; */
    }
    .process > h3 {
      font-size: 24px;
      color: #0ECAD6;
      text-align: center;
      padding-bottom: 30px;
    }
    .process > .setting {
      text-align: center;
      color: #999999;
      margin-bottom: 20px;
    }
    .process > .setting > span {
      color: #333;
    }
    .process {
      width: 800px;
      margin: 0 auto;
    }
    .process > ul {
      display: flex;
      background: #F1F7FF;
    }
    .process > ul > li {
      flex: 1;
      padding: 17px 0;
      text-align: center;
      font-size: 18px;
      color: #999999;
    }
    .process > ul > li.atPresent {
      background: url(../../../assets/img/activeAccount/articleSteps.png) no-repeat center;
      background-size: 100% 100%;
      color: #4286F5;
    }

    .process > ul > li > i {
      display: inline-block;
      width: 26px;
      height: 26px;
      border: 1px solid #999999;
      border-radius: 50%;
      margin-right: 5px;
    }
    .process > ul > li.atPresent > i, .process > ul > li.EXIST > i {
      background: #4286F5;
      border: 1px solid #4286F5;
      color: #fff;
    }
    .process > ul > li.EXIST {
      color: #4286F5;
      background-color: #E4F1FF;
    }

    .process .el-button--primary {
      font-size: 14px;
      padding: 12px 24px !important;
    }
    .process .el-input__suffix {
      /*top: 8px !important;*/
      right: 15px !important;
    }
    .process .el-input__suffix .el-input__suffix-inner {
      border-left: 1px solid #DCDFE6;
      padding-left: 15px !important;
      cursor: pointer;
    }
  }
</style>